import React from "react";
import { Square, Moon, AlertTriangle } from "lucide-react";
import { DESIGN_STATUSES, statusMeta, fmtDur, fmtHM, WORK_KEYS } from "@/lib/designTimer";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/lib/api";

export const DesignControls = ({ session, elapsed, workToday, onPick, compact, idp = "dc", overtime, forgot, workEnd, onOvertime }) => {
  const { user } = useAuth();
  const woRole = can(user, "workorders");
  const list = DESIGN_STATUSES.filter((s) => !s.hidden && (woRole || !WORK_KEYS.includes(s.key)));
  const cur = session ? statusMeta(session.status) : null;
  return (
    <div className="text-white" data-testid={`${idp}-panel`}>
      {forgot && <div className="mb-2 flex items-center gap-1.5 text-[11px] bg-rose-500/90 rounded-lg px-2 py-1.5" data-testid={`${idp}-forgot`}><AlertTriangle className="w-3.5 h-3.5 shrink-0" /> Jam kerja selesai ({workEnd}). Lupa Stop? Klik Stop atau Lembur.</div>}
      <div className="flex items-center gap-2 mb-2">
        <span className={`w-2.5 h-2.5 rounded-full ${session ? "bg-emerald-400 animate-pulse" : "bg-slate-500"}`} />
        <span className="text-xs font-semibold tracking-wide" data-testid={`${idp}-status`}>{cur ? cur.label.toUpperCase() : "BELUM MULAI"}</span>
        {session?.wo_code && <span className="text-[11px] font-mono text-slate-400 truncate" data-testid={`${idp}-wo`}>{session.wo_code}</span>}
        {!session?.wo_code && session?.activity_title && <span className="text-[11px] text-slate-400 truncate" data-testid={`${idp}-activity`}>{session.activity_title}</span>}
        <span className="ml-auto font-mono text-sm tabular-nums" data-testid={`${idp}-elapsed`}>{fmtDur(elapsed)}</span>
      </div>
      <div className={`grid ${compact ? "grid-cols-4" : "grid-cols-4 sm:grid-cols-6 xl:grid-cols-11"} gap-1.5`}>
        {list.map((s) => (
          <button key={s.key} type="button" data-testid={`${idp}-btn-${s.key.toLowerCase()}`} onClick={() => onPick(s.key)}
            className={`flex flex-col items-center justify-center gap-0.5 rounded-lg py-1.5 text-[10px] font-semibold transition-transform active:scale-95 ${session?.status === s.key ? s.cls + " ring-2 ring-white/70" : "bg-white/10 hover:bg-white/20 text-slate-200"}`}>
            <s.icon className="w-4 h-4" />{s.label}
          </button>
        ))}
        <button type="button" data-testid={`${idp}-btn-stop`} onClick={() => onPick("STOP")}
          className="flex flex-col items-center justify-center gap-0.5 rounded-lg py-1.5 text-[10px] font-semibold bg-rose-500/80 hover:bg-rose-500">
          <Square className="w-4 h-4" />Stop
        </button>
      </div>
      <div className="mt-2 flex items-center gap-2 text-[11px] text-slate-400">
        <span data-testid={`${idp}-work-today`}>Jam project hari ini: <b className="text-white">{fmtHM(workToday)}</b> / 8j</span>
        {onOvertime && <button type="button" data-testid={`${idp}-btn-overtime`} onClick={() => onOvertime(!overtime)}
          className={`ml-auto inline-flex items-center gap-1 px-2 py-1 rounded-full font-semibold ${overtime ? "bg-amber-400 text-slate-900" : "bg-white/10 text-slate-200 hover:bg-white/20"}`}>
          <Moon className="w-3 h-3" />{overtime ? "Lembur ON" : "Lembur"}</button>}
      </div>
    </div>
  );
};
